import { TitleBar } from "@shopify/app-bridge-react";
import { Page } from "@shopify/polaris";
import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AppContext } from "../../../../components/global/appContext";
import { useCreateTag, useGetTag } from "../../../../hooks/queries/tags";
import TagsForm from "./Form";
import TagsFormSkeleton from "./SkeletonForm";
import { useTranslation } from "react-i18next";

export default function TagsNew(props) {
  const { t } = useTranslation();
  const appContext = useContext(AppContext);

  const [tag, setTag] = useState(null);
  const [errors, setErrors] = useState({});
  const [tagCreated, setTagCreated] = useState(false);

  const { data, isError } = useGetTag("new");
  useEffect(() => {
    if (data) setTag(data);
  }, [data]);
  const hasUnsavedChanges = JSON.stringify(data) !== JSON.stringify(tag);

  const createTagMutation = useCreateTag({
    onSuccess: (data) => {
      setTag(data);
      appContext.setMessage(t("settings.tags.new.messages.createSuccess"));
      setErrors({});
      setTagCreated(true);
    },
    onError: (error) => {
      const errorData = error?.response?.data || {};
      if (errorData.message && !errorData.base) {
        errorData.base = [errorData.message];
      }
      if (errorData.base && !Array.isArray(errorData.base)) {
        errorData.base = [errorData.base];
      }
      setErrors(errorData);
    },
  });

  // Handle form submission (triggered by Save Bar)
  const handleSubmit = (e) => {
    e.preventDefault();
    createTagMutation.mutate(tag);
  };

  // Handle form reset (triggered by Discard button in Save Bar)
  const handleReset = (e) => {
    e.preventDefault();
    setTag(data);
  };

  if (tagCreated)
    return <Navigate to="/settings/tags" />;

  if (isError) return <p>{t("settings.tags.error")}</p>;
  if (tag)
    return (
      <form 
        data-save-bar 
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
      <Page>
        <TitleBar
          title={t("settings.tags.new.title")}
          breadcrumbs={[{ content: t("settings.tags.title"), url: "/settings/tags" }]}
        />
        <TagsForm tag={tag} setTag={setTag} errors={errors} />
      </Page>
      </form>
    );
  return (
    <Page>
      <TitleBar
        title={t("settings.tags.new.title")}
        breadcrumbs={[{ content: t("settings.tags.title"), url: "/settings/tags" }]}
      />
      <TagsFormSkeleton />
    </Page>
  );
}
